import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../utils/AuthContext';
import { hostNameBack, today, tommorrow } from '../../utils/constants';
import { enqueueSnackbar } from 'notistack';
import { MdOutlineWorkOutline } from 'react-icons/md';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { FaInfoCircle } from 'react-icons/fa';
import Loader from '../../utils/Loader';

const SetAvailabilityBtn = ({ seller, source }) => {
    const [showModal, setShowModal] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [message, setMessage] = useState('');
    const { fetchUserData } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setStartDate('');
        setEndDate('');
        setMessage('');
    };

    const handleSetUnavailable = async () => {
        if (!startDate || !endDate) {
            enqueueSnackbar('Start and end dates are required', { variant: 'error' });
            return;
        }
        if (new Date(startDate) >= new Date(endDate)) {
            enqueueSnackbar('End date must be after start date', { variant: 'error' });
            return;
        }
        try {
            setIsLoading(true);
            const token = localStorage.getItem('token');
            await axios.put(
                `${hostNameBack}/api/v1/sellers/availability/${seller._id}`,
                {
                    isAvailable: false,
                    unavailableStartDate: startDate,
                    unavailableEndDate: endDate,
                    unavailableMessage: message
                },
                { headers: { Authorization: `Bearer ${token}` } }
            ).finally(()=> setIsLoading(false));
            handleCloseModal();
            enqueueSnackbar('Availability updated successfully', { variant: 'success' });
            await fetchUserData();
        } catch (error) {
            enqueueSnackbar(error.response?.data?.error || 'Something went wrong', { variant: 'error' });
        }
    };

    const handleSetAvailable = async () => {
        try {
            setIsLoading(true);
            const token = localStorage.getItem('token');
            await axios.put(
                `${hostNameBack}/api/v1/sellers/availability/${seller._id}`,
                { isAvailable: true },
                { headers: { Authorization: `Bearer ${token}` } }
            ).finally(()=> setIsLoading(false));
            handleCloseModal();
            enqueueSnackbar('Availability updated successfully', { variant: 'success' });
            await fetchUserData();
        } catch (error) {
            enqueueSnackbar(error.response?.data?.error || 'Something went wrong', { variant: 'error' });
        }
    };

    return (
        <>

            { isLoading && <Loader type="checkmate" />}

            <button className="primaryBtn2" onClick={handleOpenModal} style={source === "sellerDashboard"? {width: "100%"} : {}}>
                <MdOutlineWorkOutline className="icon" />
                Set Availability
            </button>

            {showModal && (
                <div className="popupDiv">
                    <div className="popupContent" style={{width: "48%"}}>
                        <div className="form">
                            <h2 className="secondaryHeading">Set <span>Availability</span></h2>
                            <div className="horizontalLine"></div>

                            {seller.isAvailable ? (
                                <>
                                    <p className="infoText">
                                        {/* <FaInfoCircle className="icon" /> */}
                                        Changing availability to unavailable will no longer show your postings anywhere and you will no longer receive orders.
                                    </p>
                                    <div className="inputDiv">
                                        <label>Start Date <span>*</span></label>
                                        <input
                                            type="date"
                                            className="inputField"
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            required
                                            min={today}
                                        />
                                    </div>
                                    <div className="inputDiv">
                                        <label>End Date <span>*</span></label>
                                        <input
                                            type="date"
                                            className="inputField"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            required
                                            min={tommorrow}
                                        />
                                    </div>
                                    <div className="inputDiv">
                                        <label>Message (optional)</label>
                                        <p className="infoText">
                                            <FaInfoCircle className="icon" />
                                            This message will be shown to buyers on your profile and postings pages.
                                        </p>
                                        <textarea
                                            className="inputField"
                                            rows={3}
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            placeholder="Enter a message"
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p>
                                        You are currently unavailable from {new Date(seller.unavailableStartDate).toLocaleDateString()} to {new Date(seller.unavailableEndDate).toLocaleDateString()}.
                                    </p>
                                    {seller.unavailableMessage && <p>Message: {seller.unavailableMessage}</p>}
                                    <p>Do you want to set your availability back to available?</p>
                                </>
                            )}

                            <div className="buttonsDiv">
                                {seller.isAvailable ? (
                                    <button className="primaryBtn" onClick={handleSetUnavailable}>
                                        Set Unavailable
                                    </button>
                                ) : (
                                    <button className="primaryBtn" onClick={handleSetAvailable}>
                                        Set Available
                                    </button>
                                )}
                                <button className="secondaryBtn" onClick={handleCloseModal}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="popupCloseBtn">
                        <IoIosCloseCircleOutline className="icon" onClick={handleCloseModal} />
                    </div>
                </div>
            )}
        </>
    );
};

export default SetAvailabilityBtn;